import { Application } from "../config/const/enums";
import { yourDetailsContactFieldNames } from "../config/pageInfo/pageFieldName";
import { PATH_CONTACT_CENTER, PATH_ONLINE } from "../routes/paths";
import _ from "lodash";

export function isObjEmpty(obj) {
	if (obj == null) return true;
	return Object?.keys(obj)?.length === 0;
}

export const isObjectEmpty = (objectName) => {
	return (
		objectName &&
		Object.keys(objectName).length === 0 &&
		objectName.constructor === Object
	);
};

export const backToQuotePoint = (application) => {
	const currentDomain = window.location.origin;

	switch (application) {
		case Application.ONLINE: {
			window.location.href = `${currentDomain}${PATH_ONLINE.accept}`;
			break;
		}
		case Application.CONTACT_CENTER: {
			window.location.href = `${currentDomain}${PATH_CONTACT_CENTER.retrieveQuote}`;
			break;
		}
	}
};

export const isPromoCodeValid = (errors) => {
  const promoCodeError = _.get(
    errors,
    yourDetailsContactFieldNames("personOne").PROMO_CODE,
    null
  );
  return _.isEmpty(promoCodeError);
};
